<script lang="ts">
    import { createEventDispatcher, getContext } from "svelte";
    import type { Readable } from "svelte/store";
    import type { Fn, QuestionGridColumn, QuestionGridRow } from "../../global";
    import type { Answer } from "../../Model/Answer";

    type AnswerObject = {
        cid: string;
        rid: string;
        val: any;
    };

    export let column: QuestionGridColumn;
    export let row: QuestionGridRow;
    export let answer: Answer;

    const readonlyForm: Readable<boolean> = getContext('readonlyForm');
    const dispatch = createEventDispatcher();
    const defaultValuesMap = {
        check   : false,
        text    : '',
        amount  : 0,
        date    : '',
    };

    let saveRequestTimeout: number;
    let answerObject: AnswerObject;
    let valueReadable: Readable<AnswerObject[]>;

    $: answerChange(answer);
    $: valueUpdated($valueReadable);

    function answerChange(answer: Answer): void {
        valueReadable = answer.valueReadable;
    }

    function valueUpdated(value: AnswerObject[]): void {
        answerObject = value.find(({ cid, rid }) => rid === row.id && cid == column.id);
        if (!answerObject) {
            answerObject = {
                cid: column.id,
                rid: row.id,
                val: defaultValuesMap[column.type],
            };
            value.push(answerObject);
        }
    }

    function saveRequest(ms: number): Fn {
        return () => {
            window.clearTimeout(saveRequestTimeout);
            saveRequestTimeout = window.setTimeout(dispatchSaverequest, ms);
        };
    }

    function dispatchSaverequest(): void {
        dispatch('saverequest');
    }

</script>

{#if column.type === 'check'}
    <input
        type="checkbox"
        class="form-control-check"
        disabled={$readonlyForm}
        bind:checked={answerObject.val}
        on:change={saveRequest(0)}>
{:else if column.type === 'amount'}
    <input
        type="number"
        disabled={$readonlyForm}
        class="form-control form-control-sm"
        bind:value={answerObject.val}
        on:input={saveRequest(500)}>
{:else if column.type === 'text'}
    <input
        type="text"
        disabled={$readonlyForm}
        class="form-control form-control-sm"
        bind:value={answerObject.val}
        on:input={saveRequest(500)}>
{:else if column.type === 'date'}
    <input
        type="date"
        disabled={$readonlyForm}
        class="form-control form-control-sm"
        bind:value={answerObject.val}
        on:input={saveRequest(0)}>
{/if}
